import React from 'react';
import { format, parseISO } from 'date-fns';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { cx } from '@/styles/muiTheme';

interface DateDisplayProps {
  date: string;
  gameCount?: number;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ date, gameCount }) => {
  const parsed = parseISO(date);
  const dayOfWeek = format(parsed, 'EEEE');
  const month = format(parsed, 'MMM');
  const day = format(parsed, 'dd');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: '0.8px',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          color: cx.text.muted,
        }}
      >
        {dayOfWeek}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
        <Typography
          component="span"
          sx={{ fontSize: 36, fontWeight: 500, lineHeight: '40px', color: cx.text.primary }}
        >
          {day}
        </Typography>
        <Typography component="span" sx={{ fontSize: 14, fontWeight: 400, color: cx.text.tertiary }}>
          {month}
        </Typography>
      </Box>

      {gameCount !== undefined && (
        <Typography sx={{ mt: 1, fontSize: 11, letterSpacing: '0.15px', color: cx.border.default }}>
          {gameCount} {gameCount === 1 ? 'game' : 'games'}
        </Typography>
      )}
    </Box>
  );
};

export default DateDisplay;
